import { isThemeColor } from '../../utils';
import { ColorValue } from '../types';
import { dotToKebab } from './dotToKebab';

/**
 * Transforms a given colour value into an appropriate CSS alternative.
 * If the value is a Honeycomb theme colour option then the corresponding CSS variable is returned,
 * otherwise the value is returned unaltered.
 *
 * @param value - The color value to convert.
 * @returns A string representing the appropriate CSS value for styling.
 */
export function colorToCssValue(value: ColorValue): string {
    if (value && isThemeColor(value)) {
        const kebabCase = dotToKebab(value);
        return `var(--hc-color-${kebabCase})`;
    }

    return typeof value === 'string' ? value : 'var(--hc-color-common-black)';
}
